import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Component, inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef, MatDialogTitle
} from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TrackData } from '@shared/interfacres/track';

import { provideNativeDateAdapter } from '@angular/material/core';
import { EditTrackComponent } from '../edit-track-component/edit-track-component';
import { Genre } from '@shared/interfacres/genre';

export interface TrackModel extends Partial<TrackData> {
  currentArtist?: string;
}

@Component({
  selector: 'app-manage-track-dialog',
  templateUrl: 'manage-track-dialog.html',
  imports: [
    MatFormFieldModule,
    MatInputModule,
    FormsModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,

    ReactiveFormsModule,
    EditTrackComponent,
  ],
  providers: [
    provideNativeDateAdapter()
  ],
  styleUrl: 'manage-track-dialog.scss'
})
export class ManageTrackDialog implements OnInit {
  readonly dialogRef = inject(MatDialogRef<ManageTrackDialog>);
  readonly data = inject<{
    track: TrackData,
    genresList: Genre[],
    subgenresList: Genre[],
  }>(MAT_DIALOG_DATA);

  track: TrackModel | null = null;

  ngOnInit() {
    let releaseDate;

    if (this.data.track?.releaseDate) {
      const date = new Date(this.data.track.releaseDate);
      const minutesOffset = date.getTimezoneOffset();
      releaseDate = date.setMinutes(date.getMinutes() + minutesOffset);
      releaseDate = new Date(releaseDate).toISOString()
    } else {
      releaseDate = new Date();
    }

    this.track = {
      title: this.data.track.title,
      artists: this.data.track.artists,
      genre: this.data.track.genre,
      subgenre: this.data.track.subgenre,
      // currentArtist: '',
      bpm: this.data.track.bpm || 120,
      releaseDate: releaseDate as Date,
    };

  }



  save(): void {
    const track = {
      ...this.track,
      releaseDate: this.track?.releaseDate ? new Date(this.track?.releaseDate) : new Date()
    }
    this.dialogRef.close(track);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
